module.exports = __webpack_public_path__ + "static/invoker-cutout-e0f7ee1eb0141b568293b100fef2b867.png";